var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-card', [_c('div', {
    staticClass: "form-group row",
    staticStyle: {
      "overflow": "auto",
      "height": "100px"
    }
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('label'), _vm._v(" "), _c('b-input-group', [_c('label', {
    staticStyle: {
      "padding": "15px 0px 0px 0px"
    }
  }, [_vm._v(" Freight Charges ")]), _vm._v(" "), _c('label', {
    staticStyle: {
      "padding": "15px 0px 0px 0px"
    }
  }, [_vm._v("  =")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('label'), _vm._v(" "), _c('b-input-group', [_c('label', {
    staticStyle: {
      "padding": "15px 0px 0px 0px"
    }
  }, [_vm._v("Base Rate")]), _vm._v(" "), _c('label', {
    staticStyle: {
      "padding": "15px 0px 0px 0px"
    }
  }, [_vm._v("  x")])])], 1), _vm._v(" "), (_vm.ratebasis == 1) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('label'), _vm._v(" "), _c('b-input-group', [_c('label', {
    staticStyle: {
      "padding": "15px 0px 0px 0px"
    }
  }, [_vm._v("Billable Weight")])])], 1) : _vm._e(), _vm._v(" "), (_vm.ratebasis == 2) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('label'), _vm._v(" "), _c('b-input-group', [_c('label', {
    staticStyle: {
      "padding": "15px 0px 0px 0px"
    }
  }, [_vm._v("Number of boxes")])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {
    staticStyle: {
      "padding-top": "27px"
    }
  }, [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.saveFreightCharges('save')
      }
    }
  }, [_vm._v("Save "), _c('i', {
    staticClass: "fa fa-save"
  })]), _vm._v("    \n          "), _c('button', {
    staticClass: "-btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.saveFreightCharges('saveAndNext')
      }
    }
  }, [_vm._v("Save and Next "), _c('i', {
    staticClass: "fa fa-arrow-right"
  })])])])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c2ab1a88","hasScoped":true}!./src/modules/masterdata/views/ratetemplate/createratetemplate/freightcharges/freightcharges.html
// module id = 645
// module chunks = 3